import { render, staticRenderFns } from "./PlaylistGroup.vue?vue&type=template&id=4fd07636"
import script from "./PlaylistGroup.vue?vue&type=script&lang=js"
export * from "./PlaylistGroup.vue?vue&type=script&lang=js"
import style0 from "./PlaylistGroup.vue?vue&type=style&index=0&id=4fd07636&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports